import qs from 'qs';
import { SurveyForm } from 'routes/Dashboard/CreateSurvey/CreateSurvey.props';
import { GenericResponse } from 'types/Response';
import {SubmittedFormResponse} from 'types/services/SubmittedForm';
import {
  SurveyListResponse,
  SurveyPayload,
  SurveyResponse,
} from 'types/services/Survey';
import axiosInstance from 'utils/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/survey`;
class SurveyService {
  async create(payload: SurveyPayload): Promise<SurveyResponse> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/createSurvey`,
      payload
    );

    return data;
  }

  async update(payload: SurveyPayload, id: string): Promise<SurveyResponse> {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/updateSurvey/${id}`,
      payload
    );

    return data;
  }

  async delete(id: string): Promise<GenericResponse<void>> {
    const { data } = await axiosInstance.delete(
      `${BASE_URL}/deleteSurvey/${id}`
    );

    return data;
  }

  async getList(): Promise<SurveyListResponse> {
    const { data } = await axiosInstance.get(`${BASE_URL}/getSurveyList`);

    return data;
  }

  async getById(id: string): Promise<SurveyResponse> {
    const { data } = await axiosInstance.get(`${BASE_URL}/getSurveyById/${id}`);
    return data;
  }

  async findSurvey(enrollmentId: string, email: string): Promise<SubmittedFormResponse> {
    const { data } = await axiosInstance.get(`${BASE_URL}/findSurvey`, {params: { enrollmentId, email }})
    return data;
  }
}

export const SurveyServiceInstance = new SurveyService();
